import { render, staticRenderFns } from "./ProfileEmpresa.vue?vue&type=template&id=55898bae"
import script from "./ProfileEmpresa.vue?vue&type=script&lang=js"
export * from "./ProfileEmpresa.vue?vue&type=script&lang=js"
import style0 from "./ProfileEmpresa.vue?vue&type=style&index=0&id=55898bae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports